import { api } from "./api";

const endpoint = "volontariat/ChoixLot";
const key = "AX009XWKLMO450SHJEKAZEI";
export const LocalisationService = {
  async lister(filtre) {
    try {
      const result = await api.get(endpoint + "/all", {
        params: { filtre: { ...filtre, k: key } },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(data) {
    try {
      const result = await api.post(endpoint + "/insert", { ...data, k: key });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data) {
    try {
      const result = await api.put(endpoint + "/", { ...data, k: key });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(filtre) {
    try {
      const result = await api.delete(
        endpoint + "/" + filtre.id_choix_localisation,
        {
          params: { k: key },
        },
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(filtre) {
    try {
      const result = await api.get(endpoint + "/{id}", {
        params: { ...filtre, k: key },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
